/* eslint-disable sort-keys */
import { SET_LANGUAGE, SET_LOCALE } from './types';
export const setLanguage = language => ({
    type: SET_LANGUAGE,
    language
});
export const setLocale = locale => ({
    type: SET_LOCALE,
    locale
});
//# sourceMappingURL=creators.js.map